interface OpeningStripProps {
  name: string;
  eco: string;
  matched: number;
}

export function OpeningStrip({ name, eco, matched }: OpeningStripProps) {
  return (
    <div className="openingstrip">
      <span className="openingstrip__name" title={name}>
        {name}
      </span>
      {eco ? <span className="tag tag--quiet">{eco}</span> : null}
      <span className="openingstrip__depth">{matched} move{matched === 1 ? "" : "s"} in</span>
    </div>
  );
}
